// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum EntityPropertyGroupIdBuf {
  /**
   * This should never be used. It only exists because we must define a default 
   * for flatbuffers. We could have made the default a "useful" default but it 
   * would actually not matter since in the context of the struct (e.g. Entity
   * property id), the default is only honored if the entire struct contains
   * default values. Flatbuffers structs are fixed size constructs, so they can
   * only be present or absent as a whole. 
   */
  _Unused = 0,
  FolderDerivedSizingProperties = 255,
  FileSystemPathProperties = 256,
  FileCoreProperties = 257,
  FileDerivedProperties = 258,
  FileSecondaryDerivedProperties = 259,
  FileExtendedProperties = 8192,
  FileTagMetaProperty = 8208,
  FileRefIdMetaProperty = 8224,
  FileFolderExtendedProperties = 8960,
  FileFolderExtendedDerivedProperties = 9040,
  FileImageExtendedProperties = 9216,
  FileImageExtendedDerivedProperties = 9296,
  FileAudioExtendedProperties = 9472,
  FileAudioExtendedDerivedProperties = 9552,
  FileVideoExtendedProperties = 9728,
  FileVideoExtendedDerivedProperties = 9808,
  FileThreeDimensionalExtendedProperties = 9984,
  FileThreeDimensionalExtendedDerivedProperties = 10064,
  FileLinkExtendedProperties = 10240,
  FileLinkExtendedDerivedProperties = 10320,
  FilePdfExtendedProperties = 10496,
  FilePdfExtendedDerivedProperties = 10576,
  FileTextExtendedProperties = 12288,
  FileTextExtendedDerivedProperties = 12368,
  FilePresentationExtendedProperties = 12544,
  FilePresentationExtendedDerivedProperties = 12624,
  FileDocumentExtendedProperties = 12800,
  FileDocumentExtendedDerivedProperties = 12880,
  FileSpreadsheetExtendedProperties = 13056,
  FileSpreadsheetExtendedDerivedProperties = 13136,
  FileVendorExtendedProperties = 13312,
  FileVendorExtendedDerivedProperties = 13392,
  FileSharingUsersMetaProperty = 20992,
  FileSharingInvitesMetaProperty = 20993,
  FileCommentsMetaProperty = 21248,
  FileClientOnlyProperties = 65280,
  UserSystemProperties = 65536,
  UserCoreProperties = 65552,
  UserInterfaceDerivedProperties = 65616,
  UserSidebarOrderedItemMetaProperty = 65791,
  UserNotificationsMetaProperty = 66047,
  UserClientOnlyProperties = 130816,
  UserClientOnlyHistoryTimeline = 130817,
  UserProtectedRefreshTokenMetaProperty = 130818,
  CustomFieldCoreProperties = 196608,
  ConversationCoreProperties = 262144,
  ConversationDerivedProtectedProperties = 262160,
  ConversationGeminiTranscriptMetaProperty = 262165,
  ConversationTurnsMetaProperty = 262176,
  ConversationSharingUsersMetaProperty = 262656,
  ConversationClientOnlyProperties = 327424,
  SearchCoreProperties = 327680,
  SearchDerivedProperties = 327696,
  SearchProtectedProperties = 327697,
  SearchClientResultsMetaProperty = 327712,
  SearchClientOnlyProperties = 392960
}
